import { memo } from "react";
import Chip from "@mui/material/Chip";
import type { PubmedIngestOutcome } from "../../../../lib/corpusApi";

const OUTCOME_MAP: Record<
  PubmedIngestOutcome,
  { label: string; color: "default" | "success" | "error" | "warning" }
> = {
  ingested: { label: "Ingested", color: "success" },
  needs_review: { label: "Needs review", color: "warning" },
  rejected: { label: "Rejected", color: "error" },
  previously_rejected: { label: "Previously rejected", color: "default" },
  existing: { label: "Already in corpus", color: "default" },
};

export interface PubmedIngestOutcomeBadgeProps {
  outcome: PubmedIngestOutcome;
}

/** Chip rendering what became of one article a PubMed query ingest processed. */
export const PubmedIngestOutcomeBadge = memo(function PubmedIngestOutcomeBadge({
  outcome,
}: PubmedIngestOutcomeBadgeProps) {
  const { label, color } = OUTCOME_MAP[outcome];
  return <Chip label={label} color={color} size="small" />;
});
